import type { NavigateFunction } from "react-router-dom";

/** สถานะหน้าจัดการสินค้าที่ใช้ restore เมื่อย้อนกลับจากแก้ไขสินค้า */
export type ManageProductMainView = "สินค้า" | "คลัง";

export type ManageProductStockFilterMode = "all" | "limited" | "unlimited";

export type ManageProductSaleFilterMode = "all" | "active" | "inactive";

export type ManageProductChannelFilter = "platform" | "ext";

export type ManageProductReturnState = {
  mainView: ManageProductMainView;
  productTabKey?: string;
  stockFilterMode?: ManageProductStockFilterMode;
  inventorySaleFilter?: ManageProductSaleFilterMode;
  inventorySearchInput?: string;
  searchInput?: string;
  productChannelFilter?: ManageProductChannelFilter;
  /** แผง Collapse ที่เปิดอยู่ในมุมมองคลัง */
  inventoryExpandedKeys?: string[];
  /** ตำแหน่ง scroll ของหน้า (window.scrollY) ตอนออกจากหน้า */
  scrollTop?: number;
};

/** state ตอนไปหน้าแก้ไข — เก็บไว้ใน history / session */
export type ManageProductEditLocationState = {
  fromManageProduct?: boolean;
  returnState?: ManageProductReturnState;
};

/** state ตอนกลับมาหน้าจัดการสินค้า — ให้ ManageProduct restore */
export type ManageProductRestoreLocationState = {
  restoreManageProduct?: boolean;
  returnState?: ManageProductReturnState;
};

const STORAGE_KEY = "manage_product_return_session_v1";

export function saveManageProductReturnSession(state: ManageProductReturnState): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore storage errors (private mode / blocked)
  }
}

export function getManageProductReturnSession(): ManageProductReturnState | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as ManageProductReturnState;
  } catch {
    return null;
  }
}

export function clearManageProductReturnSession(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** ย้อนกลับจากแก้ไขสินค้า — รองรับ flow เดิม (ไป /manage-product) และ flow ใหม่ (restore มุมมองคลัง/แท็บ) */
export function navigateBackToManageProduct(
  navigate: NavigateFunction,
  locationState: unknown,
): void {
  const editState = (locationState ?? null) as ManageProductEditLocationState | null;
  const returnState =
    editState?.fromManageProduct && editState.returnState
      ? editState.returnState
      : getManageProductReturnSession();

  if (returnState) {
    navigate("/manage-product", {
      state: {
        restoreManageProduct: true,
        returnState,
      },
    });
    clearManageProductReturnSession();
    return;
  }

  navigate("/manage-product");
}
